// Display branding — the actual LLM model and engine implementation are
// configured on the backend. The UI always shows the marketing identity.
export const ENGINE_LABEL = "Remi8 AI Engine";
export const DISPLAY_MODEL = "Remi8-128B";
export const ENGINE_TAGLINE = "Government-grade Gujarati drafting";
